"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const styled_components_1 = require("styled-components");
const lodash_1 = require("lodash");
const xmldom_1 = require("xmldom");
const b = require("btoa");
const parser = new xmldom_1.DOMParser();
const serializer = new xmldom_1.XMLSerializer();
/**
 * These attributes are valid on all SVG elements and accepted by this
 * renderer.
 * All attributes will be converted to their camelCase version.
 * This allows using valid SVG strings.
 * Extend this list to allow additional default SVG attributes.
 *
 * @type {Array}
 */
const SHARED_ATTRIBUTES = ["fill", "filter", "stroke", "stroke-width"];
const ATTRIBUTES = {
    defs: [...SHARED_ATTRIBUTES],
    symbol: ["id"],
    linearGradient: [...SHARED_ATTRIBUTES, "id", "x1", "y1", "x2", "y2"],
    stop: ["offset", "stop-color"],
    circle: [...SHARED_ATTRIBUTES, "cx", "cy", "r", "style"],
    g: [...SHARED_ATTRIBUTES, "x", "y"],
    path: [...SHARED_ATTRIBUTES, "d", "style"],
    polygon: [...SHARED_ATTRIBUTES, "points"],
    rect: [...SHARED_ATTRIBUTES, "x", "y", "width", "height", "style"],
    svg: ["width", "height", "viewBox", "x", "y", "style", "xmlns", "xmlns:xlink"]
};
const TAG_NAMES = Object.keys(ATTRIBUTES);
function attributes(node, key) {
    return (ATTRIBUTES[node.tagName] || []).reduce((props, name) => {
        const attribute = node.attributes.getNamedItem(name);
        const reactProp = lodash_1.camelCase(name);
        if (attribute && attribute.specified) {
            props[reactProp] = attribute.value;
        }
        return props;
    }, { key });
}
function btoa(source) {
    return `data:image/svg+xml;base64,${b(source)}`;
}
exports.btoa = btoa;
function parse(source) {
    const doc = parser.parseFromString(source, "image/svg+xml");
    const parsed = Array.prototype.slice.call(doc.childNodes).find(node => node.tagName === "svg");
    parsed.setAttribute("xmlns", "http://www.w3.org/2000/svg");
    return parsed;
}
exports.parse = parse;
function png(source) {
    return new Promise((resolve, reject) => {
        const img = new Image();
        const canvas = document.createElement("canvas");
        const ratio = window.devicePixelRatio || 1;
        canvas.width = 16 * ratio;
        canvas.height = 16 * ratio;
        const context = canvas.getContext("2d");
        img.onload = () => {
            context.drawImage(img, 0, 0);
            resolve(canvas.toDataURL("image/png"));
        };
        img.src = btoa(source);
    });
}
exports.png = png;
function purge(parsed) {
    return Array.prototype.slice.call(parsed)
        .filter(node => TAG_NAMES.indexOf(node.tagName) > -1)
        .map(node => {
        node.childNodes = purge(node.childNodes);
        const attributes = ATTRIBUTES[node.tagName] || [];
        for (let i = 0; i < node.attributes.length; i++) {
            const attribute = node.attributes[i];
            if (attributes.indexOf(attribute.name) === -1) {
                node.removeAttribute(attribute.name);
            }
        }
        return node;
    });
}
exports.purge = purge;
;
function render(renderable) {
    const [tagName, props, children = []] = renderable;
    const { style } = props, rest = __rest(props, ["style"]);
    const tag = styled_components_1.default(tagName) `
    ${style};
  `;
    return react_1.createElement(tag, rest, children.map(c => render(c)));
}
exports.render = render;
function sanitize(parsed) {
    return Array.from(parsed)
        .filter((node) => node.hasOwnProperty('tagName'))
        .map((node, i) => [
        node.tagName,
        attributes(node, i),
        sanitize(Array.from(node.childNodes))
    ]);
}
exports.sanitize = sanitize;
function stringify(tree) {
    return serializer.serializeToString(tree);
}
exports.stringify = stringify;
function fromSource(source) {
    return render(sanitize(purge([parse(source)]))[0]);
}
exports.fromSource = fromSource;
//# sourceMappingURL=svg.js.map